import { type BuiltInTool, OPEN_OBJECT_SCHEMA } from './types'

/** Harness tools that exist for the OS's own tests. Registered so the harness knows them, never documented. */
export const INTERNAL_TOOLS: readonly BuiltInTool[] = [
    {
        name: 'echo.preview',
        family: 'internal',
        summary: 'Returns its payload unchanged. A test fixture.',
        description: 'OS tool echo.preview. Never pass vendor URLs or tokens.',
        inputSchema: OPEN_OBJECT_SCHEMA,
        returns: '`{ ok: true, echo }`: the payload it was given.',
        callers: ['run'],
        effect: 'read',
        retry: 'safe',
        errors: [],
        public: false,
    },
]
